import React from "react";

import { formatNumber, isNegative } from "../utils/reportUtils";

const getFontWeight = (type) => {
  if (type === "grand-total" || type === "sub-total" || type === "level-0") {
    return "600";
  }
  if (type === "level-1") {
    return "500";
  }
  return "normal";
};

export default function ProfitAndLossRow({
  row,
  data,
  expandedRows,
  onToggle,
  isRTL,
  level = 0,
}) {
  const isExpanded = expandedRows.has(row.id);
  const children = data.rows.filter((child) => child.parentId === row.id);
  const hasChildren = children.length > 0;
  const paddingLeft = `${5 + level * 5}px`;

  return (
    <>
      <tr
        style={{
          backgroundColor: "#ffffff",
          fontWeight: getFontWeight(row.type),
          borderBottom: "1px solid #eaeef2",
          cursor: hasChildren ? "pointer" : "default",
          color: "#333333",
        }}
        onClick={() => hasChildren && onToggle(row.id)}
      >
        {data.headers.map((header, index) => {
          const rawValue = row.values[index] || "";
          const displayValue = index === 0 ? rawValue : formatNumber(rawValue);
          const negative = index > 0 && isNegative(rawValue);

          return (
            <td
              key={`${row.id}-${header}`}
              style={{
                padding: "2px 3px",
                paddingInlineStart: index === 0 ? paddingLeft : "3px",
                textAlign:
                  index === 0
                    ? isRTL
                      ? "right"
                      : "left"
                    : isRTL
                    ? "left"
                    : "right",
                color: negative ? "#dc3545" : "#333333",
                borderInlineEnd: index === 0 ? "1px solid #eaeef2" : "none",
                whiteSpace: "nowrap",
                fontSize: "11px",
              }}
            >
              <span style={{ display: "flex", alignItems: "center" }}>
                {index === 0 && (
                  <span
                    style={{
                      width: "12px",
                      display: "inline-block",
                      marginRight: isRTL ? "0" : "4px",
                      marginLeft: isRTL ? "4px" : "0",
                      color: "#666",
                    }}
                  >
                    {hasChildren ? (isExpanded ? "▼" : "▶") : ""}
                  </span>
                )}
                <span>{displayValue}</span>
              </span>
            </td>
          );
        })}
      </tr>
      {isExpanded &&
        children.map((child) => (
          <ProfitAndLossRow
            key={child.id}
            row={child}
            data={data}
            expandedRows={expandedRows}
            onToggle={onToggle}
            isRTL={isRTL}
            level={level + 1}
          />
        ))}
    </>
  );
}
